<template>
  <div class="book">
    <div class="page left">
      <h1>士卒たる者</h1>

      <div v-for="(block, index) in japaneseBlocks" :key="'ja-'+index">
        <p class="kobun block"><strong>{{ block.kobun }}</strong></p>
        <p class="genndaibun">{{ block.translation }}</p>
      </div>
    </div>

    <div class="page right">
      <div class="video">
        <div class="video-container">
          <iframe :src="youtubeEmbedUrl" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <h2>为士卒者</h2>

      <div v-for="(block, index) in chineseBlocks" :key="'zh-'+index">
        <p class="kobun block"><strong>{{ block.kobun }}</strong></p>
        <p class="genndaibun">{{ block.translation }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
const youtubeEmbedUrl = "https://www.youtube.com/embed/视频ID";

const japaneseBlocks = [{ kobun: "士卒たるものは大工にして、手づから其道具をとぎ、色々のせめ道具をこしらへ、大工の箱に入れて持ち、", translation: "兵法において士卒たる者は、大工にたとえるなら、自ら道具を研ぎ、工夫を凝らした道具を作り、それらを道具箱に収めて携えるようなものである。" },
  { kobun: "統領云付くる所をうけ、柱がやうりやうをもてうのにてけづり、とこ・たなをもかんなにてけづり、すかし物・ほり物をもして、よくかねを糺し、すみめんどうも手ぎわ能くしたつる所、大工の法也。", translation: "棟梁の指示に従い、柱や梁を手斧で削り、床や棚を鉋で整え、透かし彫りや装飾もこなし、寸法を正確に測り、細部に至るまで手際よく仕上げることが、大工の本分である。" },
  { kobun: "大工のわざ、手にかけて能くしおぼへ、すみがねをよくしれば、後は統領となる物也。", translation: "大工の仕事を手を動かしながら身につけ、規矩や寸法に習熟すれば、やがては棟梁となれるのである。" },
  { kobun: "大工のたしなみ、よくきるゝ道具を持ち、透々にとぐ事肝要也。", translation: "大工の心得とは、常に切れ味の良い道具を備え、折に触れて丁寧に研ぎ続けることにある。それが最も大切なことだ。" },
  { kobun: "其道具をとつて、みづし・書棚・机卓、又はあんどん・まないた・鍋のふたも達者にする所、大工の専也。", translation: "大工は手にした道具を使い、御厨子や書棚、机や行灯、まな板や鍋の蓋に至るまで、何でも器用に仕上げる。それこそが大工としての本領である。" },
  { kobun: "士卒たるもの、このごとく也。能々吟味有るべし。", translation: "士卒もまた大工と同じように、技を磨き、道具を整えねばならぬ。よくよく深く考え、修行を積むべきである。" },
  { kobun: "大工のたしなみ、ひずまざる事、とめをあはする事、かんなにて能くけづる事、すりみがかざる事、後にひすかざる事、肝要なり。", translation: "大工の心得として重要なのは、木材の歪みを防ぎ、継ぎ目を正確に合わせ、鉋で美しく削り、表面に傷をつけず、乾燥後にも隙間が出ないように仕上げることである。" },
  { kobun: "此道をまなばんとおもはゞ、書顕はす所のことに心を入れて、よく吟味有るべきもの也。", translation: "この兵法の道を学びたいと思うのであれば、本書に記された一言一句を心に留め、深く吟味しなければならない。" }
];


const chineseBlocks = [{ kobun: "士卒如工，亲手磨其器，巧制诸般攻具，纳之匣中以备所用。", translation: "兵法之中，士卒就如同工匠，要亲手磨练自己的武器，精心打造各种战斗工具，并将其收于工具箱以备使用。" },
  { kobun: "领命于统领，手斧削柱梁，刨床架之材，又作镂雕刻饰，审规矩、明尺寸，精整繁细，皆乃匠人之法也。", translation: "按照棟梁的指示削柱雕梁，用手斧和刨子处理各处构件，甚至进行雕花与装饰，并精准测量、处理每一细节，这正是工匠之道。" },
  { kobun: "大工之技，亲手习之，熟知规矩尺寸，终可为匠首也。", translation: "大工若能亲手实作、精通规矩与尺寸，将来便可成为带领众人的棟梁之才。" },
  { kobun: "工匠之操，持利器以应事，时时磨砺，斯为要务。", translation: "工匠的修养，在于常备锋利之器，并在空闲时不断打磨，这才是最重要的事。" },
  { kobun: "执其器，可成厨柜、书架、几案，亦能制灯、案板、釜盖，无不精巧，斯为大工所专。", translation: "工匠手执器具，能巧制厨柜、书架、桌案，甚至连灯笼、案板、锅盖都能制作得当，这正是工匠的本职之所在。" },
  { kobun: "士卒之道，亦当如是，宜加深思慎修。", translation: "作为士卒，也应像工匠一样修技养器，须深入思考、勤加修炼。" },
  { kobun: "大工之修养，在防木曲扭，接缝严合，刨削精妙，表面无痕，干后不隙，皆为要务。", translation: "工匠的修养在于防止木材变形、精准接缝、熟练刨削、不伤表面，并确保干燥后不出现缝隙，这些都是至关重要的事项。" },
  { kobun: "欲习此道者，当用心于所载之言，细加研思，不可轻忽。", translation: "若想学习这门兵法之道，便应将文中所写之言牢记在心，反复思考、认真体会。" }
];

</script>

<style lang="scss">
@import "./fiveRingsCss.scss";
</style>
